import React, { useState, useEffect } from 'react';
import { getLogs } from '../common/whatsapp';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  TextField,
} from '@material-ui/core';
import InfoBox from '../../components/InfoIcon/InfoIcon';

const Logs = (props) => {
  const { admin, username } = props.user;
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState(null); // State for search term

  // Fetch logs data
  useEffect(() => {
    const fetchData = async () => {
      if (!admin) return;

     // setLoading(true);
      try {
        const response = await getLogs({
          admin,
          username,
          page: page + 1, // API expects 1-based page index
          limit: rowsPerPage,
          filters: { search: searchTerm }, // Pass search term as a filter
        });
        console.log("response",response)
        setList(response.data);
        setTotalCount(response.pagination.totalCount);
      } catch (err) {
        setError('Failed to fetch logs. Please try again later.');
      } finally {
       // setLoading(false);
      }
    };

    fetchData();
  }, [admin, username, page, rowsPerPage, searchTerm]); // Re-fetch when searchTerm changes

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0); // Reset to the first page when searching
  };

  return (
    <div>
      <br />
        <span style={{float:"right"}}>
                  <InfoBox name={'Whatsapp.logs'} />
              </span>
      <Typography variant="h4" gutterBottom>
        Logs
      </Typography>
      <Typography variant="body1" gutterBottom>
        View and manage logs for your WhatsApp accounts.
      </Typography>

      {/* Search Input */}
      <TextField
        label="Search by Admin, Phone ID, From, To, or Text"
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={handleSearchChange}
        style={{ marginBottom: '20px' }}
      />

      {error ? (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      ) : loading ? (
        <Typography variant="body2" color="textSecondary">
          Loading...
        </Typography>
      ) : list.length > 0 ? (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Created At</TableCell>
                  <TableCell>From</TableCell>
                  <TableCell>Phone Number ID</TableCell>
                  <TableCell>Send Text</TableCell>
                  <TableCell>Source</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>To</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item) => (
                  <TableRow key={item._id}>
                    <TableCell>{new Date(item.createdAt).toLocaleString()}</TableCell>
                    <TableCell>{item.from}</TableCell>
                    <TableCell>{item.phoneNumberId}</TableCell>
                    <TableCell>{typeof item.sendText === 'object' 
  ? item.sendText.content 
  : item.sendText}</TableCell>
                    <TableCell>{item.source}</TableCell>
                    <TableCell>{item.status ? 'True' : 'False'}</TableCell>
                    <TableCell>{item.to}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : (
        <Typography variant="body2" color="textSecondary">
          No logs found.
        </Typography>
      )}
    </div>
  );
};

export default Logs;